<template>
  <v-autocomplete
    data-private
    clearable
    dense
    outlined
    ref="singleSelect"
    :data-tourid="tourId"
    :loading="loading"
    :item-text="itemText"
    :cache-items="cacheItems"
    :hide-details="hideDetails"
    :rules="rules"
    :required="required"
    :item-value="itemValue"
    :items="options"
    :label="labelText"
    :placeholder="$t('menu.selection.select_an_option')"
    :prepend-icon="icon"
    :value="value"
    :search-input.sync="searchTerm"
    @change="handleChange"
  >
    <template v-slot:item="data">
      <v-list-item-content class="mx-0 px-0 ms-2">
        <v-list-item-title
          class="mx-0 px-0 blue-grey--text text--darken-3 mb-1"
          >{{ data.item[itemText] }}</v-list-item-title
        >
        <v-list-item-subtitle
          class="font-size-12 blue-grey--text d-flex align-center"
        >
          <v-icon
            color="blue-grey"
            size="12"
            class="me-1"
            v-if="data.item.subtitleIcon"
            >{{ data.item.subtitleIcon }}</v-icon
          >
          {{ data.item.subtitle }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'SingleSelectionAutocomplete',

  props: {
    itemValue: { type: String, required: false, default: '_id' },
    value: { type: String, required: true },
    options: { type: Array, required: false },
    label: { type: String, required: false },
    icon: { type: String, required: false },
    cacheItems: { type: Boolean, required: false, default: true },
    disabled: Boolean,
    required: { type: Boolean, required: false, default: true },
    itemText: { type: String, required: false, default: 'name' },
    loading: { type: Boolean, required: false, default: false },
    hideDetails: { type: Boolean, required: false, default: false },
    tourId: String,
  },

  data() {
    return {
      searchTerm: null,
    }
  },

  watch: {
    searchTerm: _.debounce(function(term) {
      this.$emit('search', term)
    }, 500),
  },

  computed: {
    labelText() {
      return this.required ? `${this.label}*` : this.label
    },

    cachedItems() {
      return this.$refs?.singleSelect?.cachedItems ?? this.options
    },

    rules() {
      if (!this.required) return []
      return [
        field =>
          Boolean(field?.length) ||
          this.$t('validation.form.this_field_is_required'),
      ]
    },
  },

  methods: {
    handleChange(items) {
      this.searchTerm = ''

      this.$emit('change', items)
    },
  },
}
</script>
